import { render, staticRenderFns } from "./TransporterAssetAllocateForm.vue?vue&type=template&id=6268300a&scoped=true"
import script from "./TransporterAssetAllocateForm.vue?vue&type=script&lang=js"
export * from "./TransporterAssetAllocateForm.vue?vue&type=script&lang=js"
import style0 from "./TransporterAssetAllocateForm.vue?vue&type=style&index=0&id=6268300a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268300a",
  null
  
)

export default component.exports